import { render } from "./PwaMessageModal.vue?vue&type=template&id=265cf8b7&lang=pug"
import script from "./PwaMessageModal.vue?vue&type=script&lang=js"
export * from "./PwaMessageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__